import React from "react";
import Logo from "../../assets/images/logo.png";
import { Icon } from "@iconify/react";
import { Colors } from "../Colors";

export default function Header() {
  return (
    <header className=" flex max-w-[1440] md:px-20 px-4 py-5">
      <nav
        className=" flex justify-between items-center flex-1
      "
      >
        <a className=" flex space-x-2 items-center" href="/">
          <img
            className="md:h-[42px] h-[35px] md:w-[52px] w-[45px] "
            src={Logo}
          />
          <h2
            className=" tex-[20px] md:text-[25px] "
            style={{ fontFamily: "greenStalk" }}
          >
            Angry Bears
          </h2>
        </a>

        <div className=" flex space-x-4">
          {/* <a
            style={{
              width: 40,
              height: 40,
              border: `1px solid ${Colors.modernBlack}`,
            }}
            target="_blank"
            className="flex rounded-lg items-center justify-center"
            href="#"
          >
            <Icon icon="bi:telegram" height={20} color={Colors.primary} />
          </a> */}
          <a
            style={{
              width: 40,
              height: 40,
              border: `1px solid ${Colors.modernBlack}`,
            }}
            target="_blank"
            className="flex rounded-lg items-center justify-center"
            href="https://opensea.io/collection/angry-bera-2?tab=items"
          >
            <Icon
              icon="simple-icons:opensea"
              height={20}
              color={Colors.primary}
            />
          </a>
          <a
            style={{
              width: 40,
              height: 40,
              border: `1px solid ${Colors.modernBlack}`,
            }}
            target="_blank"
            className="flex rounded-lg items-center justify-center"
            href="http://discord.gg/STyfPhAGWa"
          >
            <Icon
              icon="akar-icons:discord-fill"
              height={20}
              color={Colors.primary}
            />
          </a>
          <a
            style={{
              width: 40,
              height: 40,
              border: `1px solid ${Colors.modernBlack}`,
            }}
            target="_blank"
            className="flex rounded-lg items-center justify-center"
            href="https://x.com/Angry_BearsNFT"
          >
            <Icon icon="line-md:twitter-x" height={20} color={Colors.primary} />
          </a>
        </div>
      </nav>
    </header>
  );
}
